module.exports = __webpack_public_path__ + "static/media/custom-orders-icon.ff2da607.svg";